const determineSize = (): string => {
  const localStorageSize = localStorage.getItem('sizeOverride');
  
  const euSizing = ['AD','AT','BE','BG','HR','CH','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','VA'];
  const ukSizing = ['AU', 'GB', 'IE', 'NZ'];

  let [isEu, isUs] = [false, false]

  if (localStorageSize) {
    isEu = localStorageSize === 'eu' ? true : false;
    isUs = localStorageSize === 'us' ? true : false;
  } else {
    isEu = euSizing.includes(window.Shopify.country);
    isUs = !euSizing.includes(window.Shopify.country) && !ukSizing.includes(window.Shopify.country);
  }

  return isEu ? 'EU' : isUs ? 'US' : 'UK';
}

export default determineSize